module.exports = __webpack_public_path__ + "static/media/testimonials-3.3d677828.jpg";